export default class TasteOfTheGame {
  constructor() {
    console.info('TasteOfTheGame.constructor()');

    this.initFilters();
  }

  initFilters() {
    console.info('TasteOfTheGame.initFilters()');

    const $btn = $('.js-filter-btn');

    $btn.click((e) => {
      console.info('Click!');
      e.preventDefault();

      const $filter = $(e.currentTarget).data('filter');
      console.info($filter);

      $('.mlb-box').fadeOut();
      $('.mlb-box').each(function (e) {
        const $current = $(this).data('filter');
        console.info($current);

        if ($filter === 'all') {
          $(this).fadeIn();
        } else if ($filter === 'national') {
          if ($current === 'national-west' || $current === 'national-central' || $current === 'national-east') {
            $(this).fadeIn();
          }
        } else if ($filter === 'american') {
          if ($current === 'american-west' || $current === 'american-central' || $current === 'american-east') {
            $(this).fadeIn();
          }
        } else {
          if ($current === $filter) {
            $(this).fadeIn();
          }
        }
      });
    });
  }
}
